// Contact.jsx
import React from 'react';
import './Contact.css';

const Contact = () => {
  const contactInfo = [
    {
      icon: <i className="bi bi-envelope-fill"></i>,
      label: "Email",
      value: "srivankur82@gmail.com",
      link: "mailto:srivankur82@gmail.com"
    },
    {
      icon: <i className="bi bi-telephone-fill"></i>,
      label: "Phone",
      value: "+91-9212803190",
      link: "tel:+919212803190"
    },
    {
      icon: <i className="bi bi-geo-alt-fill"></i>,
      label: "Location",
      value: "Pune, Maharashtra",
      link: null
    },
    {
      icon: <i className="bi bi-linkedin"></i>,
      label: "LinkedIn",
      value: "Ankur Srivastava",
      link: "http://www.linkedin.com/in/ankur-srivastava-56753a15"
    }
  ];

  return (
    <section className="contact" id="contact">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Get In Touch</h2>
          <p className="section-subtitle">
            Feel free to reach out for collaborations, academic discussions, or professional opportunities.
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            {contactInfo.map((item, index) => (
              <div key={index} className="contact-item" data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="contact-icon">{item.icon}</div>

                <div className="contact-details">
                  <span className="contact-label">{item.label}</span>

                  {item.link ? (
                    <a href={item.link} className="contact-value link" target="_blank" rel="noopener noreferrer">
                      {item.value}
                    </a>
                  ) : (
                    <span className="contact-value">{item.value}</span>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="contact-availability" data-aos="fade-up" data-aos-delay="400">
            <div className="availability-card">
              <div className="availability-icon">📅</div>
              <div className="availability-content">
                <h3>Availability</h3>
                <p>
                  Open to academic collaborations, research projects, and consulting opportunities 
                  in finance and education.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Contact;
